import CustomBottomSheet from 'components/bottomSheet';
import CashPrepaymentDetail from 'components/productDetail/prepayment/cash';
import CreditPrepayment from 'components/productDetail/prepayment/credit';
import Header from 'modules/header/wholesaler/main';
import ViolationModal from 'modules/violationModal';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {ViolationReportDetailItems} from '../constants';

const PrepaymentDetailPage = () => {
  const [openViolationModal, setOpenViolationModal] = useState<boolean>(false);
  const location = useLocation();
  const {productDetail, isLoading} = useGetPostDetail(location.state.guid);
  const isFarm = location.pathname.includes('farm');
  return (
    <>
      {!isLoading && productDetail && (
        <>
          <Header title={productDetail.title} />
          {productDetail.financial_type === 'cash' && (
            <CashPrepaymentDetail
              post={productDetail}
              app="market"
              setOpenViolationModal={setOpenViolationModal}
            />
          )}
          {productDetail.financial_type === 'credit' && (
            <CreditPrepayment
              post={productDetail}
              app="market"
              setOpenViolationModal={setOpenViolationModal}
            />
          )}
        </>
      )}
      <CustomBottomSheet
        isOpen={openViolationModal}
        onDismiss={() => setOpenViolationModal(false)}
      >
        <ViolationModal
          open={openViolationModal}
          handleClose={() => setOpenViolationModal(false)}
          items={ViolationReportDetailItems}
          guid={location.state.guid}
          object_type="market"
          isFarm={isFarm}
        />
      </CustomBottomSheet>
    </>
  );
};

export default PrepaymentDetailPage;
